import type {Snapshot} from '@platform/contracts/x';
import {useWebViewport} from '@platform/ui/config';
import {PurchasePrizeGuide} from './PurchasePrizeGuide';
import {prizeGuideOffer} from './roomFlow';

// Share the mobile banner and frozen prize terms throughout the draw.
export function DesktopDrawContext({state,current}:{state:Snapshot;current:Snapshot}){
 const desktop=useWebViewport();
 const offer=prizeGuideOffer(state,current);
 if(!desktop||!offer)return null;
 return <section className="desktop-draw-context" data-draw-id={offer.drawId}>
  <PurchasePrizeGuide state={offer}/>
 </section>;
}
